export const toNiceTimeIndex = (num: number): string => (num >= 10 ? num : `0${num}`) + ".";
